import { render } from "./UserAdministratorBlockButton.vue?vue&type=template&id=e866f4a8"
import script from "./UserAdministratorBlockButton.vue?vue&type=script&lang=js"
export * from "./UserAdministratorBlockButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__